module.exports = __webpack_public_path__ + "static/media/diceRoller.e15f6ba4.png";